import React from "react";

import type { Lead } from "../types";
import { leadRepresentation } from "./sources";

const LeadList = React.lazy(() => import("./LeadList"));

export default {
  list: LeadList,
  recordRepresentation: (record: Lead) => leadRepresentation(record),
};
